import clsx from 'clsx';

import * as styles from './LightningBorder.module.css';

type LightningBorderProps = {
  className?: string;
};

export const LightningBorder: React.FC<LightningBorderProps> = ({ className }) => (
  <div className={clsx(styles.lightningBorderContainer, className)}>
    <svg className={styles.lightningBorder} viewBox='0 1 1080 83' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.5287e-06 9.14532L7.29235e-06 0.410233L1080 0.410327L1080 82.4015L746.204 46.065C744.306 45.8584 742.724 47.7266 743.048 49.7899L747.819 80.0845C748.142 82.138 746.576 84.0013 744.686 83.8117L6.5287e-06 9.14532Z'
        fill='currentColor'
      />
    </svg>
  </div>
);
